import { defineMessages } from 'react-intl';

const scope = 'app.containers.shared.EventsManagement';

export default defineMessages({
    retryBtn: {
        id: `${scope}.retryBtn`,
        defaultMessage: 'Retry',
    },
    loadingMessage: {
        id: `${scope}.loadingMessage`,
        defaultMessage: 'Fetching your data...',
    },
    errorDescription: {
        id: `${scope}.errorDescription`,
        defaultMessage:
            'Sorry, there was an error loading the rates for the selected rate band. Please try again later.',
    },
    removeButton: {
        id: `${scope}.removeButton`,
        defaultMessage: 'Remove',
    },
    // Table
    startDateColumnLabel: {
        id: `${scope}.displayTable.startDateColumnLabel`,
        defaultMessage: 'Start Date',
    },
    endDateColumnLabel: {
        id: `${scope}.displayTable.endDateColumnLabel`,
        defaultMessage: 'End Date',
    },
    nameColumnLabel: {
        id: `${scope}.displayTable.nameColumnLabel`,
        defaultMessage: 'Name',
    },
    categoryColumnLabel: {
        id: `${scope}.displayTable.categoryColumnLabel`,
        defaultMessage: 'Category',
    },
    // Modal Common
    cancelBtn: {
        id: `${scope}.modal.cancelBtn`,
        defaultMessage: 'Close',
    },
    actionErrorMessage: {
        id: `${scope}.modal.actionErrorMessage`,
        defaultMessage: 'Sorry, there was an error performing this action. Please try again later.',
    },
    // Update modal
    updateModalDisclaimer: {
        id: `${scope}.modal.updateModalDisclaimer`,
        defaultMessage: 'Any existing notes in the date range you select will be overwritten by this note.',
    },
    updateModalTitle: {
        id: `${scope}.modal.updateModalTitle`,
        defaultMessage: 'Modify Note',
    },
    applyBtn: {
        id: `${scope}.modal.applyBtn`,
        defaultMessage: 'Apply',
    },
    dateRangeLabel: {
        id: `${scope}.modal.form.dateRange.label`,
        defaultMessage: 'Date range',
    },
    noteLabel: {
        id: `${scope}.modal.form.notes.label`,
        defaultMessage: 'Note',
    },
    // Delete
    confirmDeletionText: {
        id: `${scope}.delete.confirmDeletionText`,
        defaultMessage: 'Are you sure you want to hide this event?',
    },
    confirmOk: {
        id: `${scope}.delete.confirmOk`,
        defaultMessage: 'OK- hide event',
    },
    confirmCancel: {
        id: `${scope}.delete.confirmCancel`,
        defaultMessage: 'Cancel',
    },
    deleteSuccessMessage: {
        id: `${scope}.delete.deleteSuccessMessage`,
        defaultMessage: 'Event successfully hidden',
    },
    deleteErrorMessage: {
        id: `${scope}.delete.deleteErrorMessage`,
        defaultMessage: 'Error hiding event',
    },
});
